import en from '@/i18n/translations/en.json'
import el from '@/i18n/translations/el.json'

export default {
  en,
  el
}
